import React, { useState, useEffect } from 'react';
import axiosInstance from '../../../utils/axiosSetup.js';
import { useForm } from 'react-hook-form';
import * as Yup from 'yup';
import { yupResolver } from '@hookform/resolvers/yup';
import Swal from 'sweetalert2';
import { closeModal } from '../../../action/modalbehaviour.js';

const EditChannel = ({channelId, list}) => {
    const [channelData, setChannelData] = useState(null);

    const fetchChannel = async (Id) => {      
        axiosInstance.get(`${process.env.REACT_APP_API_URL}/channels/${Id}`)
            .then(response => {
                setChannelData(response.data.data);
            })
            .catch(error => {
                console.log(error);
                setChannelData([]); 
            });
    }

    useEffect(() => {
        if (channelId) {
            fetchChannel(channelId);
        }
    },[channelId]);

    // VALIDATION RULES
    const schema = Yup.object().shape({
        name: Yup.string().required(),
        description: Yup.string().required().max(200, 'description must be upto 250 characters.')
    });
    
    const { register, handleSubmit, formState: { errors }, reset} = useForm({
        mode: 'all',
        resolver: yupResolver(schema)
    });

    useEffect(() => {
        if (channelData) {
            reset(channelData);
        }
    }, [channelData, reset]);

    const onSubmit = async (data) => {
        axiosInstance.patch(`${process.env.REACT_APP_API_URL}/channels/${channelId}`, data)
            .then(response => {
                Swal.fire({icon:"success", text:response.data.message});
                closeModal(`edit_channel_${channelId}`);
                list();
            })
            .catch(({response:{data}})=>{
                Swal.fire({text:data.message, icon:"error"});
            });
    }

    if (!channelId || !channelData) {
        return null;
    }

    return (
        <div id={`edit_channel_${channelId}`} className="modal custom-modal fade" role="dialog">
            <div className="modal-dialog modal-dialog-centered" role="document">
                <div className="modal-content">
                    <div className="modal-header">
                        <h5 className="modal-title">Edit Channel</h5>
                        <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div className="modal-body">
                        <form onSubmit={handleSubmit(onSubmit)}>
                            <div className="col-md-12">
                                <div className="input-block mb-3">
                                    <label className="col-form-label">Channel Name <span className="text-danger">*</span></label>
                                    <input className="form-control" type="text" defaultValue={channelData.name} {...register('name')}/>
                                    <div className="text-sm text-danger">
                                        {errors.name && <p>{errors.name.message}</p>}
                                    </div>
                                </div>
                            </div>
                            <div className="col-md-12">
                                <div className="input-block mb-3">
                                    <label className="col-form-label">Description <span className="text-danger">*</span></label>
                                    <textarea className="form-control" defaultValue={channelData.description} {...register('description')} rows={3}></textarea>
                                    <div className="text-sm text-danger">
                                        {errors.description && <p>{errors.description.message}</p>}
                                    </div>
                                </div>
                            </div>

                            <div className="submit-section">
                                <button type="submit" className="btn btn-primary submit-btn">UPDATE</button>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default EditChannel
